import { usePostHog } from 'posthog-js/react'
import { useEffect, useLayoutEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import {
  identifyPostHogUser,
  registerGlobalAnalyticsProperties,
  setupPostHogGroups,
} from '@/lib/analytics/posthogAnalytics'

const PostHogIdentityWrapper = ({ children }: { children: React.ReactNode }) => {
  const { user, isImpersonating } = useAuth()
  const posthogClient = usePostHog()

  // Pendant une session « en tant que », rien ne part : ni l'identité du membre, ni les gestes du support.
  // Effet de mise en page : il passe avant le `$pageview` de la page où la console envoie.
  useLayoutEffect(() => {
    if (!posthogClient) return

    if (isImpersonating) {
      posthogClient.opt_out_capturing()
    } else if (posthogClient.has_opted_out_capturing()) {
      posthogClient.opt_in_capturing()
    }
  }, [posthogClient, isImpersonating])

  useEffect(() => {
    if (!posthogClient || isImpersonating) return

    if (!user?.uid) {
      posthogClient.reset()
      return
    }

    identifyPostHogUser(user)
    registerGlobalAnalyticsProperties({
      organization_id: user.organization,
    })

    void setupPostHogGroups(user)
  }, [posthogClient, user, isImpersonating])

  return <>{children}</>
}

export default PostHogIdentityWrapper
